import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconMuteStyle0 = cosmosIconCss;

const CosmosIconMute$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconMute extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '41f6b777bc30910a926a527cecaae471b5de149c', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '513fb7d2671b058e5cea942e3ec43586f90ef1b8', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'c697f1c3561a0df5291f6ca780dbc01aaf75dc81', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m13 9.94 6.65 6.65a.51.51 0 0 1 0 .71l-.35.35a.51.51 0 0 1-.71 0L4.32 3.38a.5.5 0 0 1 0-.7l.36-.36a.5.5 0 0 1 .7 0l5 5 1.79-1.61a.5.5 0 0 1 .83.37v3.86ZM6.82 8.7l6 6a.46.46 0 0 1 .16.38v.78a.5.5 0 0 1-.83.37l-2.56-2.26H6.48a.5.5 0 0 1-.5-.5V9.05a.5.5 0 0 1 .5-.5.49.49 0 0 1 .34.15Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconMuteStyle0; }
}, [1, "cosmos-icon-mute", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-mute"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-mute":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconMute$1);
            }
            break;
    } });
}

const CosmosIconMute = CosmosIconMute$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconMute, defineCustomElement };
